import PropTypes from 'prop-types';
import Permission from './permission';
import Version from './product-version';

export default PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  package: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(Permission),
  versions: PropTypes.arrayOf(Version)
});



// WEBPACK FOOTER //
// ./src/shapes/product.js